(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('reportApp')
        .constant('CONST_REPORT', {
        	'BUTTON_BACK':'Quay lại',
        	'BUTTON_PRINT':'In báo cáo',
        	'TEMPLATE_SEQ': [{code:'contestPaymentDetail1',name:'Dữ liệu thuần'},
    	                    {code:'contestPaymentDetail2',name:'Dữ liệu nhóm'}],
            'FORMAT_EXPORT': [{code:'pdf',name:'PDF'},
    	                    {code:'excel',name:'EXCEL'}],
    	    'REPORT_TIME': [{code:'1',name:'1'},
    	                      {code:'2',name:'2'}],
            'NETOFF_DETAIL': [{code:'netoffDetailR',name:'Đã cấn trừ'},
	                      {code:'netoffDetailN',name:'Chưa cấn trừ'},
	                      {code:'netoffDetailA',name:'Điều chỉnh'},
	                      {code:'netoffDetailW',name:'Duyệt chi sai'}],     
	        'PV_STATUS_LIST':  [{code:'ED',name:'Chứng từ hợp lệ'},
	                            {code:'EI',name:'Chứng từ hợp lệ, chưa hoàn chỉnh'},
		                      {code:'AC',name:'Chứng từ không hợp lệ'},
		                      {code:'WT',name:'Chứng từ chưa cập nhật'}],   
		    'MONTHS': [{code:'01',name:'T01'},
		                      {code:'02',name:'T02'},
		                      {code:'03',name:'T03'},
		                      {code:'04',name:'T04'},
		                      {code:'05',name:'T05'},
		                      {code:'06',name:'T06'},
		                      {code:'07',name:'T07'},
		                      {code:'08',name:'T08'},
		                      {code:'09',name:'T09'},
		                      {code:'10',name:'T10'},
		                      {code:'11',name:'T11'},
		                      {code:'12',name:'T12'}],
          'PROCESS_RESULTS': [{code:'1',name:'Điều chỉnh địa chỉ'},
        	                  {code:'2',name:'Thay đổi địa chỉ'},
        	                  {code:'3',name:'Địa chỉ không đổi'},
        	                  {code:'4',name:'Cài CIU'},
        	                  {code:'5',name:'Đã điều chỉnh trên LAS'},
        	                  {code:'6',name:'Lưu tại văn phòng'},
        	                  {code:'7',name:'Lý do khác'}],
    	    'REPORT_LIST':'Danh sách báo cáo',               
    	    'REPORT_CONTEST_PAYMENT_DETAIL':'Báo cáo chi tiết chi thưởng thi đua',
    	    'REPORT_CONTEST_PAYMENT_SUMMARY':'Báo cáo tổng hợp chi thưởng thi đua',
    	    'REPORT_TAX_INVOICE_DETAIL':'Báo cáo chi tiết hóa đơn đã sử dụng', 
    	    'REPORT_TAX_INVOICE_CANCEL_DETAIL':'Báo cáo chi tiết hóa đơn đã hủy',  
    	    'REPORT_TAX_INVOICE_SUMMARY':'Báo cáo hóa đơn tổng hợp', 
    	    'REPORT_NETOFF_SUMMARY':'Báo cáo tổng hợp', 
    	    'REPORT_PAID_PAYMENT':'Báo cáo chi trả cuối ngày',  
    	    'REPORT_INVALID_ID':'Báo cáo hồ sơ/hợp đồng có cmnd quá hạn sử dụng', 
    	    'REPORT_FATCA':'Báo cáo fatca hồ sơ mới',
    	    'REPORT_DAY_END_COLLECTION': 'Báo cáo thu phí cuối ngày',
    	    'REPORT_INVESTMENT_DETAIL':'Báo cáo chi tiết cho sản phẩm đầu tư',
    	    'REPORT_NETOFF_DETAIL':'Báo cáo chi trả chi tiết',
    	    'REPORT_PAYMENT_CHECKING_VALID':'Báo cáo chi tiết tình trạng PV',
    	    'REPORT_PAYMENT_CHECKING_VALID_LOG':'Báo cáo lịch sử cập nhật PV',
    	    'REPORT_PAYMENT_CHECKING_VALID_SUMMARY':'Báo cáo tổng hợp tình trạng PV',
    	    'REPORT_COLLECTION_AT_HOME':'Báo cáo danh sách thu phí tại nhà',
    	    'REPORT_TRANSACTION_PAYMENT_REQUEST': 'Báo cáo lịch sử giao dịch chi trả',
    	    'REPORT_RETURN_LETTER_DETAILS': 'Báo cáo chi tiết xử lý thư trả về',
    	    'REPORT_RETURN_LETTER_SUMMARY': 'Báo cáo tổng hợp xử lý thư trả về',
    	    'REPORT_AGENT_INFO': 'Báo cáo hồ sơ ứng viên',
    	    'REPORT_ADVANCE_PAYMENT_AND_PAY_OFF': 'Báo cáo lịch sử cập nhật GA nộp ngân hàng',
    	    'REPORT_SUBMIT_REFUND': 'Báo cáo lịch sử cập nhật GA hoàn tạm ứng'
        });
})();
